




































import { Vue, Component } from "@/shared/vuepack";
import { useBalanceTransferStore } from "@/employee/store/balanceTransfer";
import Button from "@/shared/components/ui/Button.vue";

@Component({
  components: {
    Button
  }
})
export default class RolloverDetails extends Vue {
  balanceTransferStore = useBalanceTransferStore();

  get nextDisabled () {
    return this.$validator.errors.any();
  }

  onNext () {
    this.$validator.validateAll().then(isValid => {
      if (!isValid) {
        return;
      }

      this.balanceTransferStore.goToStep("rollover-download");
    });
  }

  onBack () {
    this.balanceTransferStore.goToStart();
  }
}
